import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { db } from "../../firebase";
import { push } from "connected-react-router";
import { getUserId } from "../../reducks/users/selectors";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
// import HomeIcon from "@material-ui/icons/Home";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import NotificationsIcon from "@material-ui/icons/Notifications";
import CommentIcon from "@material-ui/icons/Comment";
import ListAltIcon from "@material-ui/icons/ListAlt";
import AddBoxIcon from "@material-ui/icons/AddBox";
import FeaturedPlayListIcon from "@material-ui/icons/FeaturedPlayList";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import SubscriptionsIcon from "@material-ui/icons/Subscriptions";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";
import ReceiptIcon from "@material-ui/icons/Receipt";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    // backgroundColor: "#81c784",
  },
  appBar: {
    color: "#e0f2f1",
    backgroundColor: "#216174",
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));

const MyPageDrawer = () => {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  const uid = getUserId(selector);
  const [user, setUser] = useState([]);
  console.log(user);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const fechUser = () => {
    db.collection("users")
      .doc(uid)
      .get()
      .then((doc) => {
        const data = doc.data();
        setUser(data);
      });
  };

  useEffect(() => {
    fechUser();
    // eslint-disable-next-line
  }, []);

  return (
    <div className={classes.root}>
      <div className="spacer-box--l"></div>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.hide]: open,
            })}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            Account Menu
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </div>
        <Divider />
        <List>
          <ListItem button>
            <ListItemIcon>
              <ArrowBackIcon onClick={() => dispatch(push("/boothlist"))} />
            </ListItemIcon>
            <ListItemText onClick={() => dispatch(push("/boothlist"))} primary="ブース一覧に戻る" />
          </ListItem>
        </List>
        <Divider />
        <List>
          <ListItem button>
            <ListItemIcon>
              <AccountBoxIcon onClick={() => dispatch(push("/Account"))} />
            </ListItemIcon>
            <ListItemText onClick={() => dispatch(push("/Account"))} primary="プロフィール" />
          </ListItem>
        </List>
        <List>
          <ListItem button>
            <ListItemIcon>
              <NotificationsIcon onClick={() => dispatch(push("/Notification"))} />
            </ListItemIcon>
            <ListItemText onClick={() => dispatch(push("/Notification"))} primary="お知らせ" />
          </ListItem>
        </List>
        <List>
          <ListItem button>
            <ListItemIcon>
              <CommentIcon onClick={() => dispatch(push("/Transaction"))} />
            </ListItemIcon>
            <ListItemText onClick={() => dispatch(push("/Transaction"))} primary="取引情報" />
          </ListItem>
        </List>
        <Divider />
        <List>
          <ListItem button>
            <ListItemIcon>
              <AddPhotoAlternateIcon onClick={() => dispatch(push("/opus/edit"))} />
            </ListItemIcon>
            <ListItemText onClick={() => dispatch(push("/opus/edit"))} primary="作品登録" />
          </ListItem>
        </List>
        <List>
          <ListItem button>
            <ListItemIcon>
              <ListAltIcon onClick={() => dispatch(push("/OpusList"))} />
            </ListItemIcon>
            <ListItemText onClick={() => dispatch(push("/OpusList"))} primary="登録作品一覧" />
          </ListItem>
        </List>
        <Divider />
        <List>
          <ListItem button>
            <ListItemIcon>
              <AddBoxIcon onClick={() => dispatch(push("/booth/edit"))} />
            </ListItemIcon>
            <ListItemText onClick={() => dispatch(push("/booth/edit"))} primary="ブース登録" />
          </ListItem>
        </List>
        <List>
          <ListItem button>
            <ListItemIcon>
              <FeaturedPlayListIcon onClick={() => dispatch(push("/mybooth"))} />
            </ListItemIcon>
            <ListItemText onClick={() => dispatch(push("/mybooth"))} primary="登録ブース一覧" />
          </ListItem>
        </List>
        <Divider />
        <List>
          <ListItem button>
            <ListItemIcon>
              <PlayCircleFilledIcon onClick={() => dispatch(push("/movie/edit"))} />
            </ListItemIcon>
            <ListItemText onClick={() => dispatch(push("/movie/edit"))} primary="動画登録" />
          </ListItem>
        </List>
        <List>
          <ListItem button>
            <ListItemIcon>
              <SubscriptionsIcon onClick={() => dispatch(push("/movielist"))} />
            </ListItemIcon>
            <ListItemText onClick={() => dispatch(push("/movielist"))} primary="登録動画一覧" />
          </ListItem>
        </List>
        <Divider />
        <List>
          <ListItem button>
            <ListItemIcon>
              <ContactSupportIcon onClick={() => dispatch(push("/questionlist"))} />
            </ListItemIcon>
            <ListItemText onClick={() => dispatch(push("/questionlist"))} primary="質問一覧" />
          </ListItem>
        </List>
        <Divider />
        <List>
          <ListItem button>
            <ListItemIcon>
              <ReceiptIcon onClick={() => dispatch(push("/planedit"))} />
            </ListItemIcon>
            <ListItemText onClick={() => dispatch(push("/planedit"))} primary="契約プラン" />
          </ListItem>
        </List>
      </Drawer>
    </div>
  );
};

export default MyPageDrawer;
